module.exports = __webpack_public_path__ + "static/media/msl_single_4-3.beabc282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_single_4-3.jpg
// module id = 76
// module chunks = 0